export default __webpack_public_path__ + "static/media/Music.a03f2c3a.svg";